// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import {  
    IBreadcrumbItemModel,    
    ListItemFactory
} from "@app/shared";

import {
  AbstractCategoryModel
} from "@app/catalog-common";

import { PropertyModel, RoomContentModel, CategoryDto } from "@app/catalog";


export class CategoryModel extends AbstractCategoryModel implements IBreadcrumbItemModel
{
    public thumbnailUrl: WritableSignal<string>;
    public properties: WritableSignal<PropertyModel[]>;
    public roomContents: WritableSignal<RoomContentModel[]>;
    public canEdit: WritableSignal<boolean>;

    constructor()
    {
        super();
        this.thumbnailUrl = signal<string>(null);    
        this.properties = signal<PropertyModel[]>([]);
        this.roomContents = signal<RoomContentModel[]>([]);
        this.canEdit = signal<boolean>(true);
    }


    public static fromDto(dto: CategoryDto, isChecked: boolean = false)
    {
        let category = new CategoryModel();

        category.id = dto.id;
        category.name.set(dto.name);
        category.thumbnailUrl.set(dto.thumbnailUrl);
        category.canEdit.set(dto.canEdit);
        if(dto.properties) {
            category.properties.set(dto.properties.map(PropertyModel.fromDto))
        }
        if(dto.roomContents) {
            category.roomContents.set(dto.roomContents.map(RoomContentModel.fromDto))
        }    
        category.isChecked.set(isChecked);
        return category;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<CategoryModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<CategoryModel>(this.name, this.id, this, selected);

}
